import { useEffect, useState } from "react";
import { CurrentType } from "../../../enum/CurrentType";
import { useLocation } from "react-router-dom";
import { getQuote } from "../../../services/quotes";
import { TenTabLayout } from "./TenTabLayout2";
import Cookies from "js-cookie";
import useTenant from "../../../components/hooks/useTenant";


export const AddReservation = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const [currentType, setCurrentType] = useState<CurrentType>(CurrentType.ADD)
  const [data, setData] = useState<any | null>(null);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search)
  const quoteId = queryParams?.get('quoteId') ?? 0;
  const { handleTenantError }: any = useTenant();

  useEffect(() => {
    if (Number(quoteId) > 0) {
      getQuote(Number(quoteId), tenantId)
        .then(res => {
          setData(res);
          handleTenantError(null);
        })
        .catch(error => {
          setData(null)
          handleTenantError(error);
        })

      setCurrentType(CurrentType.ADD_FROM_QUOTES);
    };
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteId])

  return (
    <TenTabLayout
      currentType={currentType}
      setCurrentType={(value) => setCurrentType(value)}
      _primaryKey={0}
      data={data}
      quoteId={quoteId}
    />
  )
}